import DialogWelcomeText from "./DialogWelcomeText";

export default {
    name     : 'dialog_welcome_text',
    component: DialogWelcomeText,
    dialog   : {
        'max-width': "1000px",
        'persistent': true
    }
}
